import { createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "kt_modal_create_account",
  ref: "createAccountModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog mw-1000px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/_createVNode("h2", null, "Create Account", -1)
const _hoisted_6 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body scroll-y m-5" }
const _hoisted_9 = {
  ref: "createAccountRef",
  class: "stepper stepper-links d-flex flex-column",
  id: "kt_create_account_stepper"
}
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"stepper-nav py-5\"><div class=\"stepper-item current\" data-kt-stepper-element=\"nav\"><h3 class=\"stepper-title\">Account Type</h3></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\"><h3 class=\"stepper-title\">Account Info</h3></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\"><h3 class=\"stepper-title\">Business Details</h3></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\"><h3 class=\"stepper-title\">Billing Details</h3></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\"><h3 class=\"stepper-title\">Completed</h3></div></div>", 1)
const _hoisted_11 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_12 = { class: "w-100" }
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<div class=\"pb-10 pb-lg-15\"><h2 class=\"fw-bolder d-flex align-items-center text-dark\"> Choose Account Type <i class=\"fas fa-exclamation-circle ms-2 fs-7\" data-bs-toggle=\"tooltip\" title=\"Billing is issued based on your selected account type\"></i></h2><div class=\"text-gray-400 fw-bold fs-6\"> If you need more info, please check out <a href=\"#\" class=\"link-primary fw-bolder\">Help Page</a>. </div></div>", 1)
const _hoisted_14 = { class: "fv-row" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-lg-6" }
const _hoisted_17 = {
  class: "\n                            btn\n                            btn-outline\n                            btn-outline-dashed\n                            btn-outline-default\n                            p-7\n                            d-flex\n                            align-items-center\n                            mb-10\n                          ",
  for: "kt_create_account_form_account_type_personal"
}
const _hoisted_18 = { class: "svg-icon svg-icon-3x me-5" }
const _hoisted_19 = /*#__PURE__*/_createVNode("span", { class: "d-block fw-bold text-start" }, [
  /*#__PURE__*/_createVNode("span", { class: "text-dark fw-bolder d-block fs-4 mb-2" }, " Personal Account "),
  /*#__PURE__*/_createVNode("span", { class: "text-gray-400 fw-bold fs-6" }, "If you need more info, please check it out")
], -1)
const _hoisted_20 = { class: "col-lg-6" }
const _hoisted_21 = {
  class: "\n                            btn\n                            btn-outline\n                            btn-outline-dashed\n                            btn-outline-default\n                            p-7\n                            d-flex\n                            align-items-center\n                          ",
  for: "kt_create_account_form_account_type_corporate"
}
const _hoisted_22 = { class: "svg-icon svg-icon-3x me-5" }
const _hoisted_23 = /*#__PURE__*/_createVNode("span", { class: "d-block fw-bold text-start" }, [
  /*#__PURE__*/_createVNode("span", { class: "text-dark fw-bolder d-block fs-4 mb-2" }, "Corporate Account"),
  /*#__PURE__*/_createVNode("span", { class: "text-gray-400 fw-bold fs-6" }, "Create corporate account to mane users")
], -1)
const _hoisted_24 = { "data-kt-stepper-element": "content" }
const _hoisted_25 = { class: "w-100" }
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "pb-10 pb-lg-15" }, [
  /*#__PURE__*/_createVNode("h2", { class: "fw-bolder text-dark" }, "Account Info"),
  /*#__PURE__*/_createVNode("div", { class: "text-gray-400 fw-bold fs-6" }, [
    /*#__PURE__*/_createTextVNode(" If you need more info, please check out "),
    /*#__PURE__*/_createVNode("a", {
      href: "#",
      class: "link-primary fw-bolder"
    }, "Help Page"),
    /*#__PURE__*/_createTextVNode(". ")
  ])
], -1)
const _hoisted_27 = { class: "mb-10 fv-row" }
const _hoisted_28 = /*#__PURE__*/_createVNode("label", { class: "d-flex align-items-center form-label mb-3" }, [
  /*#__PURE__*/_createTextVNode(" Specify Team Size "),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Provide your team size to help us setup your billing"
  })
], -1)
const _hoisted_29 = {
  class: "row mb-2",
  "data-kt-buttons": "true"
}
const _hoisted_30 = { class: "col" }
const _hoisted_31 = /*#__PURE__*/_createVNode("label", {
  class: "\n                            btn\n                            btn-outline\n                            btn-outline-dashed\n                            btn-outline-default\n                            w-100\n                            p-4\n                          ",
  for: "kt_one_one_select"
}, [
  /*#__PURE__*/_createVNode("span", { class: "fw-bolder fs-3" }, "1-1")
], -1)
const _hoisted_32 = { class: "col" }
const _hoisted_33 = /*#__PURE__*/_createVNode("label", {
  class: "\n                            btn\n                            btn-outline\n                            btn-outline-dashed\n                            btn-outline-default\n                            w-100\n                            p-4\n                          ",
  for: "kt_two_ten_select"
}, [
  /*#__PURE__*/_createVNode("span", { class: "fw-bolder fs-3" }, "2-10")
], -1)
const _hoisted_34 = { class: "col" }
const _hoisted_35 = /*#__PURE__*/_createVNode("label", {
  class: "\n                            btn\n                            btn-outline\n                            btn-outline-dashed\n                            btn-outline-default\n                            w-100\n                            p-4\n                          ",
  for: "kt_ten_fifty_select"
}, [
  /*#__PURE__*/_createVNode("span", { class: "fw-bolder fs-3" }, "10-50")
], -1)
const _hoisted_36 = { class: "col" }
const _hoisted_37 = /*#__PURE__*/_createVNode("label", {
  class: "\n                            btn\n                            btn-outline\n                            btn-outline-dashed\n                            btn-outline-default\n                            w-100\n                            p-4\n                          ",
  for: "kt_fifty_select"
}, [
  /*#__PURE__*/_createVNode("span", { class: "fw-bolder fs-3" }, "50+")
], -1)
const _hoisted_38 = /*#__PURE__*/_createVNode("div", { class: "form-text" }, " Customers will see this shortened version of your statement descriptor ", -1)
const _hoisted_39 = { class: "mb-10 fv-row" }
const _hoisted_40 = /*#__PURE__*/_createVNode("label", { class: "form-label mb-3" }, "Team Account Name", -1)
const _hoisted_41 = { class: "mb-0 fv-row" }
const _hoisted_42 = /*#__PURE__*/_createVNode("label", { class: "d-flex align-items-center form-label mb-5" }, [
  /*#__PURE__*/_createTextVNode(" Select Account Plan "),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Monthly billing will be based on your account plan"
  })
], -1)
const _hoisted_43 = { class: "mb-0" }
const _hoisted_44 = { class: "d-flex flex-stack mb-5 cursor-pointer" }
const _hoisted_45 = { class: "d-flex align-items-center me-2" }
const _hoisted_46 = { class: "symbol symbol-50px me-6" }
const _hoisted_47 = { class: "symbol-label" }
const _hoisted_48 = { class: "svg-icon svg-icon-1 svg-icon-gray-600" }
const _hoisted_49 = /*#__PURE__*/_createVNode("span", { class: "d-flex flex-column" }, [
  /*#__PURE__*/_createVNode("span", { class: "\n                                fw-bolder\n                                text-gray-800 text-hover-primary\n                                fs-5\n                              " }, "Company Account"),
  /*#__PURE__*/_createVNode("span", { class: "fs-6 fw-bold text-gray-400" }, "Use images to enhance your post flow")
], -1)
const _hoisted_50 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_51 = { class: "d-flex flex-stack mb-5 cursor-pointer" }
const _hoisted_52 = { class: "d-flex align-items-center me-2" }
const _hoisted_53 = { class: "symbol symbol-50px me-6" }
const _hoisted_54 = { class: "symbol-label" }
const _hoisted_55 = { class: "svg-icon svg-icon-1 svg-icon-gray-600" }
const _hoisted_56 = /*#__PURE__*/_createVNode("span", { class: "d-flex flex-column" }, [
  /*#__PURE__*/_createVNode("span", { class: "\n                                fw-bolder\n                                text-gray-800 text-hover-primary\n                                fs-5\n                              " }, "Developer Account"),
  /*#__PURE__*/_createVNode("span", { class: "fs-6 fw-bold text-gray-400" }, "Use images to your post time")
], -1)
const _hoisted_57 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_58 = { class: "d-flex flex-stack mb-0 cursor-pointer" }
const _hoisted_59 = { class: "d-flex align-items-center me-2" }
const _hoisted_60 = { class: "symbol symbol-50px me-6" }
const _hoisted_61 = { class: "symbol-label" }
const _hoisted_62 = { class: "svg-icon svg-icon-1 svg-icon-gray-600" }
const _hoisted_63 = /*#__PURE__*/_createVNode("span", { class: "d-flex flex-column" }, [
  /*#__PURE__*/_createVNode("span", { class: "\n                                fw-bolder\n                                text-gray-800 text-hover-primary\n                                fs-5\n                              " }, "Testing Account"),
  /*#__PURE__*/_createVNode("span", { class: "fs-6 fw-bold text-gray-400" }, "Use images to enhance time travel rivers")
], -1)
const _hoisted_64 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_65 = { "data-kt-stepper-element": "content" }
const _hoisted_66 = { class: "w-100" }
const _hoisted_67 = /*#__PURE__*/_createVNode("div", { class: "pb-10 pb-lg-12" }, [
  /*#__PURE__*/_createVNode("h2", { class: "fw-bolder text-dark" }, "Business Details"),
  /*#__PURE__*/_createVNode("div", { class: "text-gray-400 fw-bold fs-6" }, [
    /*#__PURE__*/_createTextVNode(" If you need more info, please check out "),
    /*#__PURE__*/_createVNode("a", {
      href: "#",
      class: "link-primary fw-bolder"
    }, "Help Page"),
    /*#__PURE__*/_createTextVNode(". ")
  ])
], -1)
const _hoisted_68 = { class: "fv-row mb-10" }
const _hoisted_69 = /*#__PURE__*/_createVNode("label", { class: "form-label required" }, "Business Name", -1)
const _hoisted_70 = { class: "fv-row mb-10" }
const _hoisted_71 = /*#__PURE__*/_createVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createVNode("span", { class: "required" }, "Shortened Descriptor"),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "popover",
    "data-bs-trigger": "hover",
    "data-bs-html": "true",
    "data-bs-content": "\n                    <div class='p-4 rounded bg-light'>\n                        <div class='d-flex flex-stack text-muted mb-4'>\n                            <i class='fas fa-university fs-3 me-3'></i>\n\n                            <div class='fw-bold'>INCBANK **** 1245 STATEMENT</div>\n                        </div>\n\n                        <div class='d-flex flex-stack fw-bold text-gray-600'>\n                            <div>Amount</div>\n                            <div>Transaction</div>\n                        </div>\n\n                        <div class='separator separator-dashed my-2'></div>\n\n                        <div class='d-flex flex-stack text-dark fw-bolder mb-2'>\n                            <div>USD345.00</div>\n                            <div>KEENTHEMES*</div>\n                        </div>\n\n                        <div class='d-flex flex-stack text-muted mb-2'>\n                            <div>USD75.00</div>\n                            <div>Hosting fee</div>\n                        </div>\n\n                        <div class='d-flex flex-stack text-muted'>\n                            <div>USD3,950.00</div>\n                            <div>Payrol</div>\n                        </div>\n                    </div>\n                "
  })
], -1)
const _hoisted_72 = /*#__PURE__*/_createVNode("div", { class: "form-text" }, " Customers will see this shortened version of your statement descriptor ", -1)
const _hoisted_73 = { class: "fv-row mb-10" }
const _hoisted_74 = /*#__PURE__*/_createVNode("label", { class: "form-label required" }, "Corporation Type", -1)
const _hoisted_75 = /*#__PURE__*/_createVNode("option", null, null, -1)
const _hoisted_76 = /*#__PURE__*/_createVNode("option", {
  label: "Corporation",
  value: "1"
}, "Corporation", -1)
const _hoisted_77 = /*#__PURE__*/_createVNode("option", {
  label: "Sole Proprietorship",
  value: "2"
}, " Sole Proprietorship ", -1)
const _hoisted_78 = /*#__PURE__*/_createVNode("option", {
  label: "Non-profit",
  value: "3"
}, "Non-profit", -1)
const _hoisted_79 = /*#__PURE__*/_createVNode("option", {
  label: "Limited Liability",
  value: "4"
}, " Limited Liability ", -1)
const _hoisted_80 = /*#__PURE__*/_createVNode("option", {
  label: "General Partnership",
  value: "5"
}, " General Partnership ", -1)
const _hoisted_81 = { class: "fv-row mb-10" }
const _hoisted_82 = /*#__PURE__*/_createVNode("label", { class: "form-label" }, "Business Description", -1)
const _hoisted_83 = { class: "fv-row mb-0" }
const _hoisted_84 = /*#__PURE__*/_createVNode("label", { class: "fs-6 fw-bold form-label required" }, "Contact Email", -1)
const _hoisted_85 = { "data-kt-stepper-element": "content" }
const _hoisted_86 = { class: "w-100" }
const _hoisted_87 = /*#__PURE__*/_createVNode("div", { class: "pb-10 pb-lg-15" }, [
  /*#__PURE__*/_createVNode("h2", { class: "fw-bolder text-dark" }, "Billing Details"),
  /*#__PURE__*/_createVNode("div", { class: "text-gray-400 fw-bold fs-6" }, [
    /*#__PURE__*/_createTextVNode(" If you need more info, please check out "),
    /*#__PURE__*/_createVNode("a", {
      href: "#",
      class: "text-primary fw-bolder"
    }, "Help Page"),
    /*#__PURE__*/_createTextVNode(". ")
  ])
], -1)
const _hoisted_88 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_89 = /*#__PURE__*/_createVNode("label", { class: "\n                        d-flex\n                        align-items-center\n                        fs-6\n                        fw-bold\n                        form-label\n                        mb-2\n                      " }, [
  /*#__PURE__*/_createVNode("span", { class: "required" }, "Name On Card"),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Specify a card holder's name"
  })
], -1)
const _hoisted_90 = { class: "fv-plugins-message-container" }
const _hoisted_91 = { class: "fv-help-block" }
const _hoisted_92 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_93 = /*#__PURE__*/_createVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Card Number", -1)
const _hoisted_94 = { class: "position-relative" }
const _hoisted_95 = { class: "fv-plugins-message-container" }
const _hoisted_96 = { class: "fv-help-block" }
const _hoisted_97 = /*#__PURE__*/_createVNode("div", { class: "\n                          position-absolute\n                          translate-middle-y\n                          top-50\n                          end-0\n                          me-5\n                        " }, [
  /*#__PURE__*/_createVNode("img", {
    src: "media/svg/card-logos/visa.svg",
    alt: "",
    class: "h-25px"
  }),
  /*#__PURE__*/_createVNode("img", {
    src: "media/svg/card-logos/mastercard.svg",
    alt: "",
    class: "h-25px"
  }),
  /*#__PURE__*/_createVNode("img", {
    src: "media/svg/card-logos/american-express.svg",
    alt: "",
    class: "h-25px"
  })
], -1)
const _hoisted_98 = { class: "row mb-10" }
const _hoisted_99 = { class: "col-md-8 fv-row" }
const _hoisted_100 = /*#__PURE__*/_createVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Expiration Date", -1)
const _hoisted_101 = { class: "row fv-row" }
const _hoisted_102 = { class: "col-6" }
const _hoisted_103 = /*#__PURE__*/_createVNode("option", null, null, -1)
const _hoisted_104 = { class: "fv-plugins-message-container" }
const _hoisted_105 = { class: "fv-help-block" }
const _hoisted_106 = { class: "col-6" }
const _hoisted_107 = /*#__PURE__*/_createVNode("option", null, null, -1)
const _hoisted_108 = { class: "fv-plugins-message-container" }
const _hoisted_109 = { class: "fv-help-block" }
const _hoisted_110 = { class: "col-md-4 fv-row" }
const _hoisted_111 = /*#__PURE__*/_createVNode("label", { class: "\n                          d-flex\n                          align-items-center\n                          fs-6\n                          fw-bold\n                          form-label\n                          mb-2\n                        " }, [
  /*#__PURE__*/_createVNode("span", { class: "required" }, "CVV"),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Enter a card CVV code"
  })
], -1)
const _hoisted_112 = { class: "position-relative" }
const _hoisted_113 = { class: "\n                            position-absolute\n                            translate-middle-y\n                            top-50\n                            end-0\n                            me-3\n                          " }
const _hoisted_114 = { class: "svg-icon svg-icon-2hx" }
const _hoisted_115 = { class: "fv-plugins-message-container" }
const _hoisted_116 = { class: "fv-help-block" }
const _hoisted_117 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex flex-stack\"><div class=\"me-5\"><label class=\"fs-6 fw-bold form-label\">Save Card for further billing?</label><div class=\"fs-7 fw-bold text-gray-400\"> If you need more info, please check budget planning </div></div><label class=\"\n                        form-check\n                        form-switch\n                        form-check-custom\n                        form-check-solid\n                      \"><input class=\"form-check-input\" type=\"checkbox\" value=\"1\" checked=\"checked\"><span class=\"form-check-label fw-bold text-gray-400\"> Save Card </span></label></div>", 1)
const _hoisted_118 = { "data-kt-stepper-element": "content" }
const _hoisted_119 = { class: "w-100" }
const _hoisted_120 = { class: "pb-8 pb-lg-10" }
const _hoisted_121 = /*#__PURE__*/_createVNode("h2", { class: "fw-bolder text-dark" }, "Your Are Done!", -1)
const _hoisted_122 = { class: "text-gray-400 fw-bold fs-6" }
const _hoisted_123 = /*#__PURE__*/_createTextVNode(" If you need more info, please ")
const _hoisted_124 = /*#__PURE__*/_createTextVNode("Sign In")
const _hoisted_125 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_126 = { class: "mb-0" }
const _hoisted_127 = /*#__PURE__*/_createVNode("div", { class: "fs-6 text-gray-600 mb-5" }, " Writing headlines for blog posts is as much an art as it is a science and probably warrants its own post, but for all advise is with what works for your great & amazing audience. ", -1)
const _hoisted_128 = { class: "\n                        notice\n                        d-flex\n                        bg-light-warning\n                        rounded\n                        border-warning border border-dashed\n                        p-6\n                      " }
const _hoisted_129 = { class: "svg-icon svg-icon-2tx svg-icon-warning me-4" }
const _hoisted_130 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex flex-stack flex-grow-1\"><div class=\"fw-bold\"><h4 class=\"text-gray-800 fw-bolder\"> We need your attention! </h4><div class=\"fs-6 text-gray-600\"> To start using great tools, please, please <a href=\"#\" class=\"fw-bolder\">Create Team Platform</a></div></div></div>", 1)
const _hoisted_131 = { class: "d-flex flex-stack pt-15" }
const _hoisted_132 = { class: "me-2" }
const _hoisted_133 = { class: "svg-icon svg-icon-3 me-1" }
const _hoisted_134 = /*#__PURE__*/_createTextVNode(" Back ")
const _hoisted_135 = { class: "indicator-label" }
const _hoisted_136 = /*#__PURE__*/_createTextVNode(" Submit ")
const _hoisted_137 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_138 = /*#__PURE__*/_createVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createVNode("span", { class: "\n                          spinner-border spinner-border-sm\n                          align-middle\n                          ms-2\n                        " })
], -1)
const _hoisted_139 = {
  key: 1,
  type: "submit",
  class: "btn btn-lg btn-primary"
}
const _hoisted_140 = /*#__PURE__*/_createTextVNode(" Continue ")
const _hoisted_141 = { class: "svg-icon svg-icon-3 ms-1 me-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode("div", _hoisted_6, [
            _createVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode("form", {
              class: "mx-auto mw-600px w-100 py-10",
              novalidate: "novalidate",
              id: "kt_create_account_form",
              onSubmit: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.handleStep && _ctx.handleStep(...args)))
            }, [
              _createVNode("div", _hoisted_11, [
                _createVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createVNode("div", _hoisted_14, [
                    _createVNode("div", _hoisted_15, [
                      _createVNode("div", _hoisted_16, [
                        _withDirectives(_createVNode("input", {
                          type: "radio",
                          class: "btn-check",
                          name: "accountType",
                          value: "personal",
                          checked: "checked",
                          id: "kt_create_account_form_account_type_personal",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.accountType = $event))
                        }, null, 512), [
                          [_vModelRadio, _ctx.formData.accountType]
                        ]),
                        _createVNode("label", _hoisted_17, [
                          _createVNode("span", _hoisted_18, [
                            _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com005.svg" })
                          ]),
                          _hoisted_19
                        ])
                      ]),
                      _createVNode("div", _hoisted_20, [
                        _withDirectives(_createVNode("input", {
                          type: "radio",
                          class: "btn-check",
                          name: "accountType",
                          value: "corporate",
                          id: "kt_create_account_form_account_type_corporate",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.accountType = $event))
                        }, null, 512), [
                          [_vModelRadio, _ctx.formData.accountType]
                        ]),
                        _createVNode("label", _hoisted_21, [
                          _createVNode("span", _hoisted_22, [
                            _createVNode(_component_inline_svg, { src: "media/icons/duotune/finance/fin006.svg" })
                          ]),
                          _hoisted_23
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_24, [
                _createVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _createVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _createVNode("div", _hoisted_29, [
                      _createVNode("div", _hoisted_30, [
                        _withDirectives(_createVNode("input", {
                          type: "radio",
                          class: "btn-check",
                          checked: "checked",
                          name: "teamSize",
                          value: "1-1",
                          id: "kt_one_one_select",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formData.teamSize = $event))
                        }, null, 512), [
                          [_vModelRadio, _ctx.formData.teamSize]
                        ]),
                        _hoisted_31
                      ]),
                      _createVNode("div", _hoisted_32, [
                        _withDirectives(_createVNode("input", {
                          type: "radio",
                          class: "btn-check",
                          name: "teamSize",
                          value: "2-10",
                          id: "kt_two_ten_select",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formData.teamSize = $event))
                        }, null, 512), [
                          [_vModelRadio, _ctx.formData.teamSize]
                        ]),
                        _hoisted_33
                      ]),
                      _createVNode("div", _hoisted_34, [
                        _withDirectives(_createVNode("input", {
                          type: "radio",
                          class: "btn-check",
                          name: "teamSize",
                          value: "10-50",
                          id: "kt_ten_fifty_select",
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.formData.teamSize = $event))
                        }, null, 512), [
                          [_vModelRadio, _ctx.formData.teamSize]
                        ]),
                        _hoisted_35
                      ]),
                      _createVNode("div", _hoisted_36, [
                        _withDirectives(_createVNode("input", {
                          type: "radio",
                          class: "btn-check",
                          name: "teamSize",
                          value: "50+",
                          id: "kt_fifty_select",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.formData.teamSize = $event))
                        }, null, 512), [
                          [_vModelRadio, _ctx.formData.teamSize]
                        ]),
                        _hoisted_37
                      ])
                    ]),
                    _hoisted_38
                  ]),
                  _createVNode("div", _hoisted_39, [
                    _hoisted_40,
                    _createVNode(_component_Field, {
                      type: "text",
                      class: "form-control form-control-lg form-control-solid",
                      name: "teamAccountName",
                      placeholder: "",
                      value: ""
                    }),
                    _createVNode(_component_ErrorMessage, {
                      class: "fv-plugins-message-container invalid-feedback",
                      name: "teamAccountName"
                    })
                  ]),
                  _createVNode("div", _hoisted_41, [
                    _hoisted_42,
                    _createVNode("div", _hoisted_43, [
                      _createVNode("label", _hoisted_44, [
                        _createVNode("span", _hoisted_45, [
                          _createVNode("span", _hoisted_46, [
                            _createVNode("span", _hoisted_47, [
                              _createVNode("span", _hoisted_48, [
                                _createVNode(_component_inline_svg, { src: "media/icons/duotune/finance/fin001.svg" })
                              ])
                            ])
                          ]),
                          _hoisted_49
                        ]),
                        _createVNode("span", _hoisted_50, [
                          _withDirectives(_createVNode("input", {
                            class: "form-check-input",
                            type: "radio",
                            name: "accountPlan",
                            value: "1",
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.formData.accountPlan = $event))
                          }, null, 512), [
                            [_vModelRadio, _ctx.formData.accountPlan]
                          ])
                        ])
                      ]),
                      _createVNode("label", _hoisted_51, [
                        _createVNode("span", _hoisted_52, [
                          _createVNode("span", _hoisted_53, [
                            _createVNode("span", _hoisted_54, [
                              _createVNode("span", _hoisted_55, [
                                _createVNode(_component_inline_svg, { src: "media/icons/duotune/graphs/gra006.svg" })
                              ])
                            ])
                          ]),
                          _hoisted_56
                        ]),
                        _createVNode("span", _hoisted_57, [
                          _withDirectives(_createVNode("input", {
                            class: "form-check-input",
                            type: "radio",
                            checked: "",
                            name: "accountPlan",
                            value: "2",
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.formData.accountPlan = $event))
                          }, null, 512), [
                            [_vModelRadio, _ctx.formData.accountPlan]
                          ])
                        ])
                      ]),
                      _createVNode("label", _hoisted_58, [
                        _createVNode("span", _hoisted_59, [
                          _createVNode("span", _hoisted_60, [
                            _createVNode("span", _hoisted_61, [
                              _createVNode("span", _hoisted_62, [
                                _createVNode(_component_inline_svg, { src: "media/icons/duotune/graphs/gra008.svg" })
                              ])
                            ])
                          ]),
                          _hoisted_63
                        ]),
                        _createVNode("span", _hoisted_64, [
                          _withDirectives(_createVNode("input", {
                            class: "form-check-input",
                            type: "radio",
                            name: "accountPlan",
                            value: "3",
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.formData.accountPlan = $event))
                          }, null, 512), [
                            [_vModelRadio, _ctx.formData.accountPlan]
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_65, [
                _createVNode("div", _hoisted_66, [
                  _hoisted_67,
                  _createVNode("div", _hoisted_68, [
                    _hoisted_69,
                    _createVNode(_component_Field, {
                      name: "businessName",
                      class: "form-control form-control-lg form-control-solid",
                      value: "Keenthemes Inc."
                    }),
                    _createVNode(_component_ErrorMessage, {
                      class: "fv-plugins-message-container invalid-feedback",
                      name: "businessName"
                    })
                  ]),
                  _createVNode("div", _hoisted_70, [
                    _hoisted_71,
                    _createVNode(_component_Field, {
                      name: "shortenedDescriptor",
                      class: "form-control form-control-lg form-control-solid",
                      value: "KEENTHEMES"
                    }),
                    _createVNode(_component_ErrorMessage, {
                      class: "fv-plugins-message-container invalid-feedback",
                      name: "shortenedDescriptor"
                    }),
                    _hoisted_72
                  ]),
                  _createVNode("div", _hoisted_73, [
                    _hoisted_74,
                    _createVNode(_component_Field, {
                      name: "corporationType",
                      class: "form-select form-select-lg form-select-solid",
                      as: "select"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_75,
                        _hoisted_76,
                        _hoisted_77,
                        _hoisted_78,
                        _hoisted_79,
                        _hoisted_80
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ErrorMessage, {
                      class: "fv-plugins-message-container invalid-feedback",
                      name: "corporationType"
                    })
                  ]),
                  _createVNode("div", _hoisted_81, [
                    _hoisted_82,
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "businessDescription",
                      class: "form-control form-control-lg form-control-solid",
                      rows: "3"
                    }),
                    _createVNode(_component_ErrorMessage, {
                      class: "fv-plugins-message-container invalid-feedback",
                      name: "businessDescription"
                    })
                  ]),
                  _createVNode("div", _hoisted_83, [
                    _hoisted_84,
                    _createVNode(_component_Field, {
                      name: "contactEmail",
                      class: "form-control form-control-lg form-control-solid",
                      value: "corp@support.com"
                    }),
                    _createVNode(_component_ErrorMessage, {
                      class: "fv-plugins-message-container invalid-feedback",
                      name: "contactEmail"
                    })
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_85, [
                _createVNode("div", _hoisted_86, [
                  _hoisted_87,
                  _createVNode("div", _hoisted_88, [
                    _hoisted_89,
                    _createVNode(_component_Field, {
                      type: "text",
                      class: "form-control form-control-solid",
                      placeholder: "",
                      name: "nameOnCard"
                    }),
                    _createVNode("div", _hoisted_90, [
                      _createVNode("div", _hoisted_91, [
                        _createVNode(_component_ErrorMessage, { name: "nameOnCard" })
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_92, [
                    _hoisted_93,
                    _createVNode("div", _hoisted_94, [
                      _createVNode(_component_Field, {
                        type: "text",
                        class: "form-control form-control-solid",
                        placeholder: "Enter card number",
                        name: "cardNumber"
                      }),
                      _createVNode("div", _hoisted_95, [
                        _createVNode("div", _hoisted_96, [
                          _createVNode(_component_ErrorMessage, { name: "cardNumber" })
                        ])
                      ]),
                      _hoisted_97
                    ])
                  ]),
                  _createVNode("div", _hoisted_98, [
                    _createVNode("div", _hoisted_99, [
                      _hoisted_100,
                      _createVNode("div", _hoisted_101, [
                        _createVNode("div", _hoisted_102, [
                          _createVNode(_component_Field, {
                            name: "expirationMonth",
                            class: "form-select form-select-solid",
                            "data-control": "select2",
                            "data-hide-search": "true",
                            "data-placeholder": "Month",
                            as: "select"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_103,
                              (_openBlock(), _createBlock(_Fragment, null, _renderList(12, (i) => {
                                return _createVNode("option", {
                                  key: i,
                                  label: i,
                                  value: i
                                }, _toDisplayString(i), 9, ["label", "value"])
                              }), 64))
                            ]),
                            _: 1
                          }),
                          _createVNode("div", _hoisted_104, [
                            _createVNode("div", _hoisted_105, [
                              _createVNode(_component_ErrorMessage, { name: "expirationMonth" })
                            ])
                          ])
                        ]),
                        _createVNode("div", _hoisted_106, [
                          _createVNode(_component_Field, {
                            name: "expirationYear",
                            class: "form-select form-select-solid",
                            "data-control": "select2",
                            "data-hide-search": "true",
                            "data-placeholder": "Year",
                            as: "select"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_107,
                              (_openBlock(), _createBlock(_Fragment, null, _renderList(10, (i) => {
                                return _createVNode("option", {
                                  key: i,
                                  label: new Date().getFullYear() + i,
                                  value: new Date().getFullYear() + i
                                }, _toDisplayString(new Date().getFullYear() + i), 9, ["label", "value"])
                              }), 64))
                            ]),
                            _: 1
                          }),
                          _createVNode("div", _hoisted_108, [
                            _createVNode("div", _hoisted_109, [
                              _createVNode(_component_ErrorMessage, { name: "expirationYear" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_110, [
                      _hoisted_111,
                      _createVNode("div", _hoisted_112, [
                        _createVNode(_component_Field, {
                          type: "text",
                          class: "form-control form-control-solid",
                          minlength: "3",
                          maxlength: "4",
                          placeholder: "CVV",
                          name: "cvv"
                        }),
                        _createVNode("div", _hoisted_113, [
                          _createVNode("span", _hoisted_114, [
                            _createVNode(_component_inline_svg, { src: "media/icons/duotune/finance/fin002.svg" })
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_115, [
                        _createVNode("div", _hoisted_116, [
                          _createVNode(_component_ErrorMessage, { name: "cvv" })
                        ])
                      ])
                    ])
                  ]),
                  _hoisted_117
                ])
              ]),
              _createVNode("div", _hoisted_118, [
                _createVNode("div", _hoisted_119, [
                  _createVNode("div", _hoisted_120, [
                    _hoisted_121,
                    _createVNode("div", _hoisted_122, [
                      _hoisted_123,
                      _createVNode(_component_router_link, {
                        to: "/sign-in",
                        class: "link-primary fw-bolder"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_124
                        ]),
                        _: 1
                      }),
                      _hoisted_125
                    ])
                  ]),
                  _createVNode("div", _hoisted_126, [
                    _hoisted_127,
                    _createVNode("div", _hoisted_128, [
                      _createVNode("span", _hoisted_129, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen044.svg" })
                      ]),
                      _hoisted_130
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_131, [
                _createVNode("div", _hoisted_132, [
                  _createVNode("button", {
                    type: "button",
                    class: "btn btn-lg btn-light-primary me-3",
                    "data-kt-stepper-action": "previous",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.previousStep()))
                  }, [
                    _createVNode("span", _hoisted_133, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr063.svg" })
                    ]),
                    _hoisted_134
                  ])
                ]),
                _createVNode("div", null, [
                  (_ctx.currentStepIndex === _ctx.totalSteps - 1)
                    ? (_openBlock(), _createBlock("button", {
                        key: 0,
                        type: "submit",
                        class: "btn btn-lg btn-primary",
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.formSubmit()))
                      }, [
                        _createVNode("span", _hoisted_135, [
                          _hoisted_136,
                          _createVNode("span", _hoisted_137, [
                            _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                          ])
                        ]),
                        _hoisted_138
                      ]))
                    : (_openBlock(), _createBlock("button", _hoisted_139, [
                        _hoisted_140,
                        _createVNode("span", _hoisted_141, [
                          _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                        ])
                      ]))
                ])
              ])
            ], 32)
          ], 512)
        ])
      ])
    ])
  ], 512))
}